import _ from 'lodash';
const moment = require('moment');

class AddAlertMessageController {
  constructor(bannerMessageService) {
    this.name = 'addAlertMessage';
    this.DATE_FORMAT = 'dd-MMMM-yyyy';
    this.bannerMessageService = bannerMessageService;
    this.isReleaseDatePickerOpened = {
      startDate: false,
      endDate: false
    };
    this.releaseInfo = {
      startTime : '',
      endTime: '',
      startDate: '',
      endDate: ''
    };
    this.setErrorSuccessMsgDefaults();
    this.setDefaultStartEndTime();
  }

  setDefaultStartEndTime() {
    this.releaseInfo.startTime = moment(new Date()).startOf('day');
    this.releaseInfo.endTime = moment(new Date()).endOf('day');
  }

  expand(field) {
    this.isReleaseDatePickerOpened[field] = true;
  }

  submit(form) {
    if (form.$valid) {
      this.setErrorSuccessMsgDefaults();
      this.doTimeValidation();
      if (!this.hasInvalidTime) {
        this.bannerMessageService.setMessage(this.getMessage(),this.getExpirationTime())
          .then(
            this.onSetMessageSuccess.bind(this),
            this.onSetMessageFailure.bind(this)
          );
      }
    } else {
      this.touchFormFields(form);
    }
  }

  getExpirationTime() {
    let epochStartTime = new Date().getTime() / 1000;
    let epochEndTime =  this.getEpochTime(this.releaseInfo.endTime);
    return Math.round(epochEndTime - epochStartTime);
  }

  onDateChange(fieldChanged ,fieldToChange) {
    this.setErrorSuccessMsgDefaults();
    this.releaseInfo[fieldToChange] = new Date(this.releaseInfo[fieldChanged].getTime());
  }

  getMessage() {
    let releaseStartDate = moment(this.releaseInfo.startDate).format('LL');
    let releaseEndDate = moment(this.releaseInfo.endDate).format('LL');
    let releaseStartTime = moment(this.releaseInfo.startTime).format('LT');
    let releaseEndTime = moment(this.releaseInfo.endTime).format('LT');
    return `Access Manager will be unavailable between ${releaseStartDate}  ${releaseStartTime} EST -  ${releaseEndDate}  ${releaseEndTime} EST`;
  }

  onSetMessageSuccess() {
    this.setMessageHasSucceeded = true;
  }

  onSetMessageFailure() {
    this.hasServerError = true;
  }

  doTimeValidation() {
    let epochStartTime = this.getEpochTime(this.releaseInfo.startTime);
    let epochEndTime =  this.getEpochTime(this.releaseInfo.endTime);
    if (epochStartTime > epochEndTime) {
      this.hasInvalidTime = true;
    }
  }

  getEpochTime(time) {
    return new Date(time).getTime() / 1000;
  }

  isInvalidDate(form) {
    return form.startDate.$error.date || form.endDate.$error.date;
  }

  isFormErroneous(form, field) {
    return form[field].$error;
  }

  isRequiredInputFieldTouchedAndEmpty(form, field) {
    return form[field].$touched && form[field].$error.required;
  }

  touchFormFields(form) {
    let fields = this.getFormFields(form);
    _.each(fields, function(field) {
      if (field.$pristine) {
        field.$setTouched(true);
      }
    });
  }

  getFormFields(form) {
    let fields = [];
    _.each(form, function(value, key) {
      let firstLetter = key.slice(0, 1);
      if (firstLetter !== '$') {
        fields.push(value);
      }
    });
    return fields;
  }

  setErrorSuccessMsgDefaults() {
    this.hasInvalidTime = false;
    this.setMessageHasSucceeded = false;
    this.hasServerError = false;
  }

  isSubmitDisabled(form) {
    return this.hasInvalidTime || form.$invalid;
  }
}

AddAlertMessageController.$inject = ['bannerMessageService'];

export default AddAlertMessageController;


// WEBPACK FOOTER //
// ./app/components/addAlertMessage/addAlertMessage.controller.js